import { Injectable } from '@angular/core';
import { GTMDataLayer } from '../models/googleTagManager.model';
import { GtmEvents, StoreTypeEnum } from '../enums/gtm.enum';
import { NavigationEnd, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { AuthService } from '@spartacus/core';
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  currentUrl: string;
  user: any;
  customerAccount: any;
  activeSalesArea: any;
  localActiveSalesArea: any;
  customerCountry: any;
  constructor(
    private router: Router,
    protected userAccountFacade: UserAccountFacade,
    protected authService: AuthService,
    private commonService: CommonService,
  ) {
    this.getUser();
    this.getCustomerAccount();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }
  getUser() {
    this.authService
      .isUserLoggedIn()
      .pipe(
        switchMap((isUserLoggedIn) => {
          if (isUserLoggedIn) {
            return this.userAccountFacade.get();
          } else {
            return of(undefined);
          }
        })
      )
      .subscribe((res: any) => {
        if (res) {
          this.user = res;
        }
      });
  }
  
  getCustomerAccount() {
    this.commonService.getUserData().subscribe((res) => {
      let currentUser = res;
      if (res?.name && res?.uid) {
        this.customerAccount = `${currentUser?.orgUnit?.name}-${currentUser?.orgUnit?.uid}`;
        this.activeSalesArea = currentUser['recentSalesArea']?.uid;
        this.customerCountry = currentUser['recentSalesArea']?.salesAreaAddress?.country?.isocode;
      } else{
        this.customerAccount = 'Guest';
      }
    })
  }
  
  sendEvent(gtmData: GTMDataLayer): void {
    globalThis.dataLayer = globalThis.dataLayer || [];
    gtmData = {
      ...gtmData,
      user_scope: this.user?.email ? 'Logged In' : 'Guest',
      customerAccount: this.customerAccount || 'Guest',
      customerCountry: this.customerCountry || 'Guest',
      sales_area:
        this.activeSalesArea ||
        this.localActiveSalesArea?.salesAreaId.split('_')[0],
    };
    // if (!Object.values(GtmEvents).includes(gtmData.event)) {
    globalThis.dataLayer.push(gtmData);
    // }
  }
}
